import type { ReactNode } from 'react'
import type { AccountContext as AccountContextType } from '@/types'
import { AccountCtx } from './accountCtx'

interface AccountProviderProps {
  children: ReactNode
  account: AccountContextType | null
  isLoading: boolean
  error: string | null
  reloadAccount: () => Promise<void>
}

export function AccountProvider({ children, account, isLoading, error, reloadAccount }: AccountProviderProps) {
  return (
    <AccountCtx.Provider value={{ account, isLoading, error, reloadAccount }}>
      {children}
    </AccountCtx.Provider>
  )
}
